import { render } from "./VideoPage.vue?vue&type=template&id=61bc3cc6"
import script from "./VideoPage.vue?vue&type=script&lang=js"
export * from "./VideoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__